/**
 * Logger - Sistema de logging del sensor
 * 
 * Proporciona métodos de logging (debug, info, warn, error) que respetan
 * el flag de configuración 'debug'. Los mensajes se prefijan con [ADR LEVEL]
 * para facilitar el filtrado en consola.
 */

export class Logger {
	constructor(config) {
		this.config = config;
	}

	debug(message, ...args) {
		if (this.config?.get?.('debug')) {
			console.debug('[ADR DEBUG]', message, ...args);
		}
	}

	info(message, ...args) {
		if (this.config?.get?.('debug')) {
			console.info('[ADR INFO]', message, ...args);
		}
	}

	warn(message, ...args) {
		if (this.config?.get?.('debug')) {
			console.warn('[ADR WARN]', message, ...args);
		}
	}

	error(message, ...args) {
		if (this.config?.get?.('debug')) {
			console.error('[ADR ERROR]', message, ...args);
		}
	}
}

export default Logger;

